/**
 * Pluralize helper function
 * @param {string} word
 * @param {number} length
 * @returns Singular or plural string
 */
export default function pluralize(word: string, length: number): string {
  if (length !== 1) word += "s";
  return word;
}
